export class CollapsibleController {
    heading: string;
    private initiallyCollapsed: boolean;
    collapsed: boolean = true;
    
    /* @ngInject */
    constructor() {
        if (typeof this.initiallyCollapsed === "boolean") {
            this.collapsed = this.initiallyCollapsed;
        }
    }
    
    toggleCollapse() {
        this.collapsed = !this.collapsed;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/collapsible/collapsible.controller.ts